import { ChevronDownIcon } from '@shared/assets/icons';
import { LockedFieldLabel } from '@shared/ui/locked-field-label';
import styles from './locked-select-field.module.scss';

interface LockedSelectFieldProps {
  label: string;
  value: string;
}

export const LockedSelectField = ({ label, value }: LockedSelectFieldProps) => {
  return (
    <div>
      <LockedFieldLabel label={label} />
      <div className={styles.container}>
        <span className={styles.text}>{value}</span>
        <span className={styles.icon}>
          <ChevronDownIcon />
        </span>
      </div>
    </div>
  );
};
